import axios from 'axios';
import {
  PRODUCT_ENDPOINT,
  PRODUCT_MASTER_ENDPOINT,
  PRODUCT_MASTER_PROPAGATE_ENDPOINT
} from '@dynameat/constants';

export const productMasterListRequest = () => axios.get(PRODUCT_MASTER_ENDPOINT(), { params: { page_size: 0 } });
export const createProductMasterRequest = (productMaster) => axios.post(PRODUCT_MASTER_ENDPOINT(), productMaster);
export const updateProductMasterRequest = (productMasterGuid, productMaster) => axios.patch(PRODUCT_MASTER_ENDPOINT(productMasterGuid), productMaster);
export const deleteProductMasterRequest = (productMasterGuid) => axios.delete(PRODUCT_MASTER_ENDPOINT(productMasterGuid));
export const propagateProductMasterRequest = (productMasterGuid) => axios.post(PRODUCT_MASTER_PROPAGATE_ENDPOINT(productMasterGuid));

// Products
export const productListSearchRequest = async (cancelToken, customParams = {}) => {
  try {
    return await axios.get(PRODUCT_ENDPOINT(), {
      params: { page_size: 200, ...customParams }, cancelToken
    });
  } catch (error) {
    if (!axios.isCancel(error)) throw error;
  }
  return undefined;
};
